import React from "react";

function Photos() {
  return (
    <div className="rightSide">
      <img className="imgBody" src="img/Figure_5.jpg" />
      <img className="imgBody" src="img/Figure_20.jpg" />
      <img className="imgBody" src="img/Figure_21.jpg" />
      <img className="imgBody" src="img/Figure_22.jpg" />
      <img className="imgBody" src="img/Figure_24.jpg" />
    </div>
  );
}
export default Photos;
